import { TransformOptions, TreeData, TreeNodeData } from '../Tree'
import { cloneDeep } from 'lodash-es'

export const toTreeNodes = (array: TreeData, options?: TransformOptions) => {
  const idKey = options && options.idKey ? options.idKey : 'id'
  const pIdKey = options && options.pIdKey ? options.pIdKey : 'pid'
  const rootPId = options && options.rootPId ? options.rootPId : undefined
  const childrenKey = options && options.childrenKey ? options.childrenKey : 'children'

  const allNodes = cloneDeep(array)
  const treeNodes = allNodes.filter((item) => (rootPId ? item[pIdKey] == rootPId : !item[pIdKey]))

  treeNodes.forEach((item) => {
    toTreeNodesRecursive(item, allNodes, idKey, pIdKey, childrenKey)
  })

  return treeNodes
}

const toTreeNodesRecursive = (node: TreeNodeData, allNodes: TreeData, idKey: string, pIdKey: string, childrenKey: string) => {
  const treeNodes = allNodes.filter((item) => item[pIdKey] == node[idKey])

  treeNodes.forEach((item) => {
    toTreeNodesRecursive(item, allNodes, idKey, pIdKey, childrenKey)
  })

  if (treeNodes.length > 0) {
    node[childrenKey] = treeNodes
  }
}

export const toArray = (treeNodes: TreeData, options?: TransformOptions) => {
  const idKey = options && options.idKey ? options.idKey : 'id'
  const pIdKey = options && options.pIdKey ? options.pIdKey : 'pid'
  const rootPId = options && options.rootPId ? options.rootPId : undefined
  const childrenKey = options && options.childrenKey ? options.childrenKey : 'children'

  const allNodes: TreeData = []
  const array = cloneDeep(treeNodes)
  array.forEach((item) => {
    toArrayRecursive(item, allNodes, idKey, pIdKey, childrenKey)

    delete item[childrenKey]
    item[pIdKey] = rootPId
    allNodes.push(item)
  })

  return allNodes
}

const toArrayRecursive = (node: TreeNodeData, allNodes: TreeData, idKey: string, pIdKey: string, childrenKey: string) => {
  if (!node[childrenKey] || node[childrenKey].length == 0) {
    return
  }

  const array: TreeData = node[childrenKey]
  array.forEach((item) => {
    toArrayRecursive(item, allNodes, idKey, pIdKey, childrenKey)

    delete item[childrenKey]
    item[pIdKey] = node[idKey]
    allNodes.push(item)
  })
}
